"use client"

import { updateUserData } from "src/integrations/lib/userData"
import { IntegrationScript } from "../lib/IntegrationScript"

const src = "https://connect.facebook.net/en_US/fbevents.js"

export const MetaPixelTag = () => {
  return <IntegrationScript id="meta_pixel" src={src} onLoad={updateUserData} />
}
